"use client"
import { Button } from "@/components/ui/button"
import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "@/components/ui/card"
import { ArrowRight, Building2, UserCheck } from "lucide-react"
import Link from "next/link"
import { useTranslations } from "next-intl"

export default function SignupPage() {
	const t = useTranslations("auth.signup")
	return (
		<>
			<div className="text-center mb-12">
				<h2 className="text-3xl font-bold text-gray-900 mb-4">
					{t("title")}
				</h2>
				<p className="text-gray-600 text-lg max-w-2xl mx-auto">
					{t("description")}
				</p>
			</div>

			<div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
				<Card className="hover:shadow-xl transition-all duration-300 border-2 hover:border-main/40 cursor-pointer group">
					<CardHeader className="text-center pb-6">
						<div className="bg-main/10 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-main/15 transition-colors">
							<UserCheck className="h-10 w-10 text-main" />
						</div>

						<CardTitle className="text-2xl font-bold text-gray-900 mb-2">
							{t("employee.title")}
						</CardTitle>
						<CardDescription className="text-gray-600 text-base leading-relaxed">
							{t("employee.description")}
						</CardDescription>
					</CardHeader>
					<CardContent className="pt-0">
						<div className="space-y-3 mb-8">
							<div className="flex items-center before:content-[''] before:w-2 before:h-2 before:bg-main before:rounded-full gap-1 text-gray-700">
								<span>{t("employee.features.profile")}</span>
							</div>
							<div className="flex items-center before:content-[''] before:w-2 before:h-2 before:bg-main before:rounded-full gap-1 text-gray-700">
								<span>{t("employee.features.search")}</span>
							</div>
							<div className="flex items-center before:content-[''] before:w-2 before:h-2 before:bg-main before:rounded-full gap-1 text-gray-700">
								<span>{t("employee.features.apply")}</span>
							</div>
							<div className="flex items-center before:content-[''] before:w-2 before:h-2 before:bg-main before:rounded-full gap-1 text-gray-700">
								<span>{t("employee.features.support")}</span>
							</div>
							<div className="flex items-center before:content-[''] before:w-2 before:h-2 before:bg-main before:rounded-full gap-1 text-gray-700">
								<span>{t("employee.features.training")}</span>
							</div>
						</div>
						<Link href="/signup/employee" className="block">
							<Button className="w-full">
								<ArrowRight className="me-2 h-5 w-5" />
								{t("employee.button")}
							</Button>
						</Link>
					</CardContent>
				</Card>

				<Card className="hover:shadow-xl transition-all duration-300 border-2 hover:border-alternative/40 cursor-pointer group">
					<CardHeader className="text-center pb-6">
						<div className="bg-alternative/10 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-alternative/15 transition-colors">
							<Building2 className="h-10 w-10 text-alternative" />
						</div>
						<CardTitle className="text-2xl font-bold text-gray-900 mb-2">
							{t("organization.title")}
						</CardTitle>
						<CardDescription className="text-gray-600 text-base leading-relaxed">
							{t("organization.description")}
						</CardDescription>
					</CardHeader>
					<CardContent className="pt-0">
						<div className="space-y-3 mb-8">
							<div className="flex items-center before:content-[''] before:w-2 before:h-2 before:bg-alternative before:rounded-full gap-1 text-gray-700">
								<span>
									{t("organization.features.post_jobs")}
								</span>
							</div>
							<div className="flex items-center before:content-[''] before:w-2 before:h-2 before:bg-alternative before:rounded-full gap-1 text-gray-700">
								<span>
									{t("organization.features.search_talent")}
								</span>
							</div>
							<div className="flex items-center before:content-[''] before:w-2 before:h-2 before:bg-alternative before:rounded-full gap-1 text-gray-700">
								<span>
									{t(
										"organization.features.manage_applications"
									)}
								</span>
							</div>
							<div className="flex items-center before:content-[''] before:w-2 before:h-2 before:bg-alternative before:rounded-full gap-1 text-gray-700">
								<span>
									{t("organization.features.consulting")}
								</span>
							</div>
							<div className="flex items-center before:content-[''] before:w-2 before:h-2 before:bg-alternative before:rounded-full gap-1 text-gray-700">
								<span>
									{t("organization.features.reports")}
								</span>
							</div>
						</div>
						<Link href="/signup/organization" className="block">
							<Button variant="alternative" className="w-full">
								<ArrowRight className="me-2 h-5 w-5" />
								{t("organization.button")}
							</Button>
						</Link>
					</CardContent>
				</Card>
			</div>

			<div className="text-center mt-12">
				<p className="text-gray-600 text-lg">
					{t("already_have_account")}{" "}
					<Link
						href="/login"
						className="text-main hover:text-main/90 font-medium transition-colors"
					>
						{t("login_link")}
					</Link>
				</p>
			</div>
		</>
	)
}
